import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { apolloClient } from '@izi-logistics/common/lib/api/apolloClient';

const client: ApolloClient<NormalizedCacheObject> = apolloClient(process.env.REACT_APP_API_URL);
const URL = process.env.REACT_APP_API_URL;
export { client, URL };
